var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-xs-left"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('app-view-spacer',{attrs:{"marginTop":'0'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }